import { useMemo, useCallback } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'

export enum TaskViewMode {
  List = 'list',
  Board = 'board',
  Calendar = 'calendar',
}

const VIEW_MODE_PATH_MAP: Record<TaskViewMode, string> = {
  [TaskViewMode.List]: '/app/tasks/list',
  [TaskViewMode.Board]: '/app/tasks/board',
  [TaskViewMode.Calendar]: '/app/tasks/calendar',
}

const pathToViewMode = (pathname: string): TaskViewMode => {
  if (pathname.includes('/tasks/board')) return TaskViewMode.Board
  if (pathname.includes('/tasks/calendar')) return TaskViewMode.Calendar
  return TaskViewMode.List
}

export type UseTaskViewStateResult = {
  viewMode: TaskViewMode
  setViewMode: (mode: TaskViewMode) => void
}

export const useTaskViewState = (): UseTaskViewStateResult => {
  const location = useLocation()
  const navigate = useNavigate()

  const viewMode = useMemo(() => pathToViewMode(location.pathname), [location.pathname])

  const setViewMode = useCallback(
    (mode: TaskViewMode) => {
      const targetPath = VIEW_MODE_PATH_MAP[mode]
      if (location.pathname !== targetPath) {
        navigate(targetPath)
      }
    },
    [location.pathname, navigate]
  )

  return { viewMode, setViewMode }
}
